import React from "react"
import { Box } from "@mui/material"

import { AppOfficesBlock } from "@components"
import AppOfficesBlockContainer from "@components/DataBlocks/OfficesContainer"


export default function officeColumn() {
	return {
		name: "dropDownFilter", label: "Office",
		options: {
			headerAlign: "left",
			customBodyRowRenderLite: (_, row, idx) => {
				return <Box sx={{ textAlign: 'center' }}>
					<AppOfficesBlockContainer rows={row.pickUp}/>
					<AppOfficesBlock
						key={idx}
						name={row.dropDown.name}
						type={row.dropDown.type}
						typeDrop={row.dropDown.type}
						country={row.dropDown.country}
					/>
				</Box>
			}
		}
	}
}